<script setup lang="ts">
export type BoxPosition = 'top-left' | 'top-right' | 'right'
export interface BoxProps {
    classes?: string
    color?: ColorsCms
    decorPosition?: BoxPosition
    decor?: boolean
    padding?: string
    size?: 'normal' | 'small'
}

const props = withDefaults(defineProps<BoxProps>(), {
    classes: 'rounded',
    color: 'gray-1',
    decorPosition: 'top-left',
    decor: true,
    padding: 'px-2 py-10 px-lg-6 py-lg-15',
    size: 'normal',
})
</script>

<template>
  <div
    :style="
      props.color
        ? {
          backgroundColor: `var(--box-bg-color-${props.color})`,
          '--box-decor-bg-color': `var(--box-bg-color-${props.color})`,
        }
        : ''
    "
    class="position-relative"
    :class="[
      props.padding,
      props.classes,
      props.color,
      `box-decor-size-${props.size}`,
      `box-decor-${props.decorPosition}`,
      { 'box-decor': props.decor },
    ]"
  >
    <slot />
  </div>
</template>
<style>
@import './Box.vars.scss';
</style>
<style scoped lang="scss">
@import './Box.scss';
</style>
